export const TIMESTAMP_UNITS: { [key: string]: number } = {
	year: 24 * 60 * 60 * 1000 * 365,
	month: (24 * 60 * 60 * 1000 * 365) / 12,
	week: 24 * 60 * 60 * 1000 * 7,
	day: 24 * 60 * 60 * 1000,
	hour: 60 * 60 * 1000,
	minute: 60 * 1000,
	second: 1000,
};

export const isThisYear = (date: Date, viennaNow: Date) => {
	const now = viennaNow;
	return now.getFullYear() === date.getFullYear();
};

export const isYesterday = (date: Date, viennaNow: Date) => {
	// NOTE: create new Date – otherwise viennaNow will be compromised
	const yesterday = new Date(viennaNow);
	yesterday.setDate(yesterday.getDate() - 1);
	yesterday.setHours(0, 0, 0, 0);
	return date.getTime() >= yesterday.getTime() && !isToday(date, viennaNow);
};

export const isToday = (date: Date, viennaNow: Date) => {
	// NOTE: create new Date – otherwise viennaNow will be compromised
	const today = new Date(viennaNow);
	today.setHours(0, 0, 0, 0);
	return date.getTime() >= today.getTime();
};

export const isLastHour = (date: Date, viennaNow: Date) => {
	return date.getTime() > viennaNow.getTime() - TIMESTAMP_UNITS.hour;
};

export function getViennaNow(): Date {
	const now: Date = new Date();
	// NOTE: 'en-US' is not relevant – ISO 8601 date is built out of parts
	const formatter: Intl.DateTimeFormat = new Intl.DateTimeFormat('en-US', {
		timeZone: 'Europe/Vienna',
		hour12: false,
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		fractionalSecondDigits: 3,
	});

	// Formatted current time
	const parts: { [key: string]: string } = formatter
		.formatToParts(now)
		.reduce((acc: { [key: string]: string }, part: Intl.DateTimeFormatPart) => {
			acc[part.type] = part.value;
			return acc;
		}, {});

	// Combining the formatted parts into an ISO 8601 date
	const formattedNow: string = `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}.${parts.fractionalSecond}Z`;

	// Creating a Date object in the Vienna time zone
	const viennaTime: Date = new Date(formattedNow);

	// Convert time zone offset (in minutes) to milliseconds
	const timeZoneOffset: number = now.getTimezoneOffset() * 60000;

	// Creating a Date object with the correct offset
	const localTime: Date = new Date(viennaTime.getTime() + timeZoneOffset);

	return localTime;
}
